import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './svg-icon.module.scss';
import spritesheet from 'assets/img/icons/spritesheet.svg';

const SvgIcon = props => {
  const { className, name } = props;
  const xlink = `${spritesheet}#${name}`;

  return (
    <svg className={classnames(className, styles.icon, styles[name])}>
      <use xlinkHref={xlink} />
    </svg>
  );
};

SvgIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default SvgIcon;
